var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 16.0564V17.2387C2.40039 18.1832 2.77968 19.089 3.45481 19.7569C4.12994 20.4248 5.04561 20.8 6.00039 20.8H18.0004C18.9552 20.8 19.8708 20.4248 20.546 19.7569C21.2211 19.089 21.6004 18.1832 21.6004 17.2387V16.0516M12.0004 2.39999V15.4581M12.0004 15.4581L16.2004 11.3032M12.0004 15.4581L7.80039 11.3032",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0587fd6c862955311a60401ac38e2ad1.svg";
export { ForwardRef as ReactComponent };